/* eslint-disable */
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// import Vuetify, { VLayout } from 'vuetify/lib'
import VueCurrencyFilter from 'vue-currency-filter';
import VueGlobalVariable from 'vue-global-var'
import VueLoaders from 'vue-loaders'
import 'vue-loaders/dist/vue-loaders.css'
import { chrome } from 'vue-color'
import store from '@/store/store'
let configFile = 'fgConfig'
// let configFile = 'pfConfig'

if(process.env.ENV_CONFIG)
  configFile=process.env.ENV_CONFIG
var configData = require(`../../config/${configFile}.json`)  
import * as VueGoogleMaps from 'vue2-google-maps'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import OtpInput from "@bachdgvn/vue-otp-input";
import VueSimpleMarkdown from 'vue-simple-markdown'
import Api from "@/services/Api.js";
import 'vue-simple-markdown/dist/vue-simple-markdown.css'

Vue.use(VueSimpleMarkdown)

Vue.component("v-otp-input", OtpInput);
// if (process.env.NODE_ENV === 'staging') {
//   Vue.use(VueReCaptcha, { siteKey: '6LeQ0ewZAAAAACkX-OZqlHWLcfn4Amfh6HHDzH0_' })
// } if (process.env.NODE_ENV === 'production') {
//   Vue.use(VueReCaptcha, { siteKey: '6LeQ0ewZAAAAACkX-OZqlHWLcfn4Amfh6HHDzH0_' })
// } else {
//   Vue.use(VueReCaptcha, { siteKey: '6Lfl5NMZAAAAANZHi9-9la6SqfmYFIPTSsffqU4k' })
// }

Vue.prototype.configData = configData
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCx5XyqRBUCh1S4NxBPxqsps_9tSNj1k20',
    libraries: 'places,drawing', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
    installComponents: true
  }}),

Vue.config.productionTip = false

Vue.component('chromepicker', chrome)

Vue.use(VueCurrencyFilter, {
  symbol: 'R',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.use(VueLoaders);
// Vue.use(Vuetify, {
//   components: {
//       VLayout
//   }
// })
const VAT = 0.15

Vue.use(VueGlobalVariable, {
  globals: {
    VAT: 0.15
  },
});
Vue.prototype.$VAT = VAT


Api().get('/customer/show/organisation').then(async response=>{
  console.log(response.data)
  await store.dispatch("setCurrentOrg", response.data)
  }).then( r=>{
    new Vue({
      vuetify,
      router,
      VAT,
      store,
      render: h => h(App)
    }).$mount('#app')
    
  }).catch(e=>{
    console.log(e)
  });


